module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigation"
  }, [_c('div', {
    staticClass: "title mobile-hide"
  }, [_vm._v("Rachel Frantsen Lee | " + _vm._s(_vm._f("title")(_vm.active)) + "\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "nav-wrapper mobile-hide"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: ("nav-item-" + index),
      staticClass: "nav-item",
      class: {
        active: item === _vm.active
      },
      on: {
        "click": function($event) {
          return _vm.navigateTo(item)
        }
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(_vm._f("title")(item)) + "\n\t\t")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "mobile-label mobile-show"
  }, [_vm._v("\n\t\t" + _vm._s(_vm._f("title")(_vm.active)) + "\n\t")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-351f9fa0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 114
// module chunks = 1